import { useState } from 'react';
import CollegeBackground from '../assets/NtcCollege/CollegeBackground.jpeg';
import NYILogo from '../assets/NYI-logo.jpeg';
import NMILogo from '../assets/NMI-logo.jpeg';
import NDILogo from '../assets/NDI-logo.jpg';

const tabs = [
  'District Office',
  'NYI',
  'NMI',
  'NDI',
  'Evangelism',
  'NTC College',
  'Creative Ministries',
  'Core Ministries',
];

function MinistryHeader({ eyebrow, title, description }) {
  return (
    <div className="mb-12">
      <span className="text-[10px] font-black text-crimson uppercase tracking-[0.4em] block mb-4">
        {eyebrow}
      </span>
      <h2 className="text-3xl md:text-4xl font-black text-navy-blue tracking-tighter mb-4">
        {title}
      </h2>
      {description && (
        <p className="text-slate-500 font-light leading-relaxed max-w-2xl">
          {description}
        </p>
      )}
    </div>
  );
}

function ComingSoon() {
  return (
    <div className="border border-slate-200 rounded-xl bg-[#FCFAF5] px-8 py-10">
      <span className="text-[10px] font-black text-atlantic uppercase tracking-[0.4em] block mb-3">
        More Information
      </span>
      <p className="text-slate-400 font-light text-sm leading-relaxed max-w-md">
        Additional information about this ministry will be added here.
      </p>
    </div>
  );
}

export default function Ministries() {
  const [activeTab, setActiveTab] = useState('District Office');

  return (
    <div className="bg-sand/60/10 min-h-screen selection:bg-atlantic/30">

      {/* Hero — DO NOT CHANGE */}
      <section className="relative py-20 md:py-28 px-4 md:px-6 text-center overflow-hidden bg-white">
        <div className="relative z-10 max-w-4xl mx-auto">
          <h1 className="text-3xl md:text-4xl lg:text-6xl font-black text-white mb-6 uppercase tracking-tighter">
            <span className="text-atlantic">Our </span>
            <span className="text-atlantic italic font-serif">Ministries</span>
          </h1>
          <p className="text-base md:text-xl text-sky/80 font-light max-w-2xl mx-auto leading-relaxed">
            Serving the Western Cape through intentional ministry and discipleship.
          </p>
        </div>
      </section>

      {/* Tabs */}
      <section className="bg-white border-b border-slate-200 sticky top-0 z-20">
        <div className="max-w-7xl mx-auto px-4 md:px-6 overflow-x-auto">
          <div className="flex gap-0 min-w-max">
            {tabs.map((tab) => (
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                className={`px-5 py-4 text-[10px] font-black uppercase tracking-[0.3em] transition-colors border-b-2 -mb-[1px] whitespace-nowrap ${
                  activeTab === tab
                    ? 'border-crimson text-crimson'
                    : 'border-transparent text-slate-400 hover:text-navy-blue'
                }`}
              >
                {tab}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Tab Content */}
      <section className="py-16 md:py-24 px-4 md:px-6 bg-white">
        <div className="max-w-5xl mx-auto">

          {/* District Office */}
          {activeTab === 'District Office' && (
            <div>
              <MinistryHeader
                eyebrow="District Office"
                title="District Advisory Board"
                description="The governing body supporting the District Superintendent in the leadership of the Western Cape District."
              />
              <hr className="border-slate-200 mb-10" />
              <ComingSoon />
            </div>
          )}

          {/* NYI */}
          {activeTab === 'NYI' && (
            <div>
              <div className="flex flex-col md:flex-row items-start gap-8 md:gap-12 mb-12">
                <div className="shrink-0">
                  <img src={NYILogo} alt="NYI Logo" className="h-20 w-20 object-contain" />
                </div>
                <div>
                  <span className="text-[10px] font-black text-crimson uppercase tracking-[0.4em] block mb-4">
                    Nazarene Youth International
                  </span>
                  <h2 className="text-3xl md:text-4xl font-black text-navy-blue tracking-tighter mb-4">NYI</h2>
                  <p className="text-slate-500 font-light leading-relaxed max-w-2xl">
                    Empowering young people to grow in faith, serve their communities, and impact the world for Christ.
                  </p>
                </div>
              </div>
              <hr className="border-slate-200 mb-10" />
              <ComingSoon />
            </div>
          )}

          {/* NMI */}
          {activeTab === 'NMI' && (
            <div>
              <div className="flex flex-col md:flex-row items-start gap-8 md:gap-12 mb-12">
                <div className="shrink-0">
                  <img src={NMILogo} alt="NMI Logo" className="h-20 w-20 object-contain" />
                </div>
                <div>
                  <span className="text-[10px] font-black text-crimson uppercase tracking-[0.4em] block mb-4">
                    Nazarene Missions International
                  </span>
                  <h2 className="text-3xl md:text-4xl font-black text-navy-blue tracking-tighter mb-4">NMI</h2>
                  <p className="text-slate-500 font-light leading-relaxed max-w-2xl">
                    Mobilising the local church to pray, give, and go in support of global missions.
                  </p>
                </div>
              </div>
              <hr className="border-slate-200 mb-10" />
              <ComingSoon />
            </div>
          )}

          {/* NDI */}
          {activeTab === 'NDI' && (
            <div>
              <div className="flex flex-col md:flex-row items-start gap-8 md:gap-12 mb-12">
                <div className="shrink-0">
                  <img src={NDILogo} alt="NDI Logo" className="h-20 w-20 object-contain" />
                </div>
                <div>
                  <span className="text-[10px] font-black text-crimson uppercase tracking-[0.4em] block mb-4">
                    Nazarene Discipleship International
                  </span>
                  <h2 className="text-3xl md:text-4xl font-black text-navy-blue tracking-tighter mb-4">NDI</h2>
                  <p className="text-slate-500 font-light leading-relaxed max-w-2xl">
                    Equipping believers to become Christlike disciples who make disciples in every sphere of life.
                  </p>
                </div>
              </div>
              <hr className="border-slate-200 mb-10" />
              <ComingSoon />
            </div>
          )}

          {/* Evangelism */}
          {activeTab === 'Evangelism' && (
            <div>
              <MinistryHeader
                eyebrow="Evangelism"
                title="Reaching the Lost"
                description="Proclaiming the gospel through intentional outreach across the Western Cape."
              />
              <hr className="border-slate-200 mb-10" />
              <div className="grid grid-cols-1 md:grid-cols-3 gap-0 border-t border-slate-200">
                {[
                  {
                    num: '01',
                    title: 'Campaign & Open Air',
                    desc: 'Bringing the gospel to the streets and public spaces through organised evangelism campaigns.',
                  },
                  {
                    num: '02',
                    title: 'Jesus Film',
                    desc: 'Using the Jesus Film as a powerful tool to share the life and message of Christ with communities.',
                  },
                  {
                    num: '03',
                    title: 'Church Planting',
                    desc: 'Establishing new congregations in unreached areas to extend the Kingdom of God.',
                  },
                ].map((item, i) => (
                  <div
                    key={i}
                    className={`py-8 md:py-10 px-0 md:px-8 ${
                      i !== 0 ? 'border-t md:border-t-0 md:border-l border-slate-200' : ''
                    }`}
                  >
                    <span className="text-[10px] font-black text-crimson tracking-[0.2em] block mb-4">
                      {item.num}
                    </span>
                    <h4 className="text-base font-black text-navy-blue tracking-tight mb-3">
                      {item.title}
                    </h4>
                    <p className="text-slate-500 text-sm font-light leading-relaxed">{item.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* NTC College */}
          {activeTab === 'NTC College' && (
            <div>
              <div className="relative h-72 md:h-96 rounded-2xl overflow-hidden mb-12">
                <img
                  src={CollegeBackground}
                  alt="NTC College"
                  className="w-full h-full object-cover object-center"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-navy-blue via-navy-blue/50 to-transparent" />
                <div className="absolute bottom-8 left-8">
                  <span className="text-[10px] font-black text-sand/70 uppercase tracking-[0.3em] block mb-2">
                    Nazarene Theological College
                  </span>
                  <h2 className="text-3xl md:text-4xl font-black text-white tracking-tighter">
                    NTC College
                  </h2>
                </div>
              </div>
              <hr className="border-slate-200 mb-10" />
              <ComingSoon />
            </div>
          )}

          {/* Creative Ministries */}
          {activeTab === 'Creative Ministries' && (
            <div>
              <MinistryHeader
                eyebrow="Creative Ministries"
                title="Creative Ministries"
                description="Using arts, media, and creativity to glorify God and communicate the gospel in fresh and engaging ways."
              />
              <hr className="border-slate-200 mb-10" />
              <ComingSoon />
            </div>
          )}

          {/* Core Ministries */}
          {activeTab === 'Core Ministries' && (
            <div>
              <MinistryHeader
                eyebrow="Core Ministries"
                title="Core Ministries"
                description="The foundational ministries that form the heartbeat of every local church in the Western Cape District."
              />
              <hr className="border-slate-200 mb-10" />
              <ComingSoon />
            </div>
          )}

        </div>
      </section>

    </div>
  );
}